import {Box, Dialog, DialogContent, DialogTitle, Divider} from '@mui/material';
import {Job} from '@cp/model';
import JobDetailDialogHeader from './JobDetailDialogHeader';
import JobDetailDialogStatus from './JobDetailDialogStatus';
import JobDetailDialogInfo from './JobDetailDialogInfo';
import JobDetailDialogErrors from './JobDetailDialogErrors';
import JobDetailDialogLogs from './JobDetailDialogLogs';

interface JobDetailDialogProps {
  job: Job | null;
  open: boolean;
  onClose: () => void;
}

export default function JobDetailDialog({job, open, onClose}: JobDetailDialogProps) {
  if (!job) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {minHeight: '60vh'},
      }}
    >
      <DialogTitle>
        <JobDetailDialogHeader onClose={onClose} />
      </DialogTitle>

      <DialogContent>
        <Box sx={{display: 'flex', flexDirection: 'column', gap: 3}}>
          <JobDetailDialogStatus job={job} />

          <Divider />

          <JobDetailDialogInfo job={job} />

          <JobDetailDialogErrors job={job} />

          <Divider />

          <JobDetailDialogLogs job={job} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
